import React, { Fragment } from 'react';

import { connect } from 'redux-zero/react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Field, Formik } from 'formik';
import { Helmet } from 'react-helmet';


import { withLocaleContext } from '../../locales/locale-context.js';
import { actions } from '../../shared/store.js';
import { validateEmail } from '../../shared/utils.js';
import { PrimaryButton } from '../../components/ui-toolkit/buttons.js';
import ErrorMessage from '../../components/error-message/error-message.component.js';
import HomePageService from '../home/home.service.js';
import {
	FormTextBox,
	FormTextArea,
} from '../../components/ui-toolkit/form-inputs.js';
import PageHeader from '../../components/page-header/page-header.component.js';
import NotImplemented from '../../components/not-implemented/not-implemented.js';
import IconLabel from '../../components/icon-label/icon-label.component.js';
import ServicesService from './services.service.js';
import FinancialSVG from '../../assets/icons/services/financialSVG.js';
import GrantsSVG from '../../assets/icons/services/grantsSVG.js';
import ManagementSVG from '../../assets/icons/services/managementSVG.js';
import TechTransferSVG from '../../assets/icons/services/techTransferSVG.js';
import Categories from '../../components/physical-installation-categories/categories';
import Physinstallationslider from '../../components/physical-installation-slider/physical-installation-slider';


import success from '../../assets/icons/success.svg';
import './services.scss';
import '../../components/ui-toolkit/buttons.scss';


const Success = ({ title, description }) => (
	<div className="center-xs success row">
		<div className="col-xs-12 center-xs">
			<img src={success} alt="Success" />
		</div>
		<div className="col-xs-12 col-md-9 center-xs">
			<h3>{title}</h3>
		</div>
		<div className="col-xs-12 col-md-4 center-xs">
			<h6>{description}</h6>
		</div>
	</div>
);

class ServicesPage extends React.Component {
	static prefetchData = async language => ServicesService.getServicesPageData(language);

	state = {
		hasError: false,
		submittedForm: false,
		hasFormError: false,
		selectCategory: null,
		selectColor: '#32C878',
	};


	componentDidMount() {
		const { servicesPageData, setLoading } = this.props;
		if (!servicesPageData) {
			this.fetchData();
		} else {
			setLoading(false);
			this.setState({selectCategory: servicesPageData.physicalInstallationSlide[0]})
		}
	}

	componentDidUpdate(prevProps) {
		const {
			localeContext: { locale },
		} = this.props;

		if (prevProps.localeContext.locale.value !== locale.value) {
			this.fetchData();
		}
	}

	fetchData() {
		const {
			setLoading,
			setServicesPageData,
			localeContext: { locale },
		} = this.props;

		setLoading(true);

		ServicesPage.prefetchData(locale.value)

			.then(({ data }) => {
				this.setState({
					selectCategory: data.physicalInstallationSlide[0],
				});
				setServicesPageData(data);
				setLoading(false);

			})
			.catch(() => {
				setLoading(false);

				this.setState({
					hasError: true,
				});
			});
	}


	render() {

		const { hasError, submittedForm, hasFormError, selectCategory } = this.state;
		const { isLoading, servicesPageData, intl } = this.props;

		if (isLoading) return null;

		if (hasError || !servicesPageData) {
			return <NotImplemented />;
		}

		const {
			topLabel,
			title,
			description,
			physicalInstallation,
			physicalInstallationSlide,
			virtualInstallation,
			businessDevSupport,
			biotechEquipmentServices,
		} = servicesPageData;

		const setSelectCategory = (category) => {
			this.setState({
				selectCategory: category,
			});
		};

		return (
			<Fragment>
				<div id="services-page">
					<Helmet>
						<title>
							{intl.formatMessage({
								id: 'navigation.services',
							})}
						</title>
					</Helmet>
					<section className="header">
						<div className="container container-fluid">
							<div className="row">
								<div className="col-xs-12 col-md-5 middle-xs title">
									<div className="container">
										<div className="row">
											<div className="col-xs-12">
												<div className="button-section">
													<PageHeader title={topLabel} />
												</div>
											</div>
											<div className="col-xs-12">
												<div className="title-label">
													<h2>{title}</h2>
												</div>
											</div>
											<div className="col-xs-12">
												<div className="description">
													<p>{description}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="col-xs-12 col-md-7 header-image" />
							</div>
						</div>
					</section>
					<section className="physical-installation">
						<div className="container container-fluid">
							<div className="row text-row">
								<div className="col-xs-12 col-md-12 center-md title phinstallation">
									<h3>{physicalInstallation.Title}</h3>
								</div>
								<div className="col-xs-12 col-md-12 center-md description ph-installation">
									<p>{physicalInstallation.Description}</p>
								</div>
							</div>
							<div className="row">
								<div className="col-xs-12 col-sm-12 col-md-7 col-lg-6">
									<Categories categories={physicalInstallationSlide} setSelectCategory={setSelectCategory} selectCategoryName={selectCategory && selectCategory.value && selectCategory.value.categoryname} />
								</div>
								<div className="col-xs-12 col-sm-12 col-md-5 col-lg-6">
									<div className="slide">
										<Physinstallationslider category={selectCategory}/>
									</div>
								</div>
							</div>
						</div>
					</section>
					<section className="virtual-installation">
						<div className="container container-fluid">
							<div className="row">
								<div className="col-xs-12 col-md-6 middle-xs title">
									<div className="container">
										<div className="row">
											<div className="col-xs-12">
												<div className="button-section">
													<PageHeader
														title={virtualInstallation.sectionTitle}
													/>
												</div>
											</div>
											<div className="col-xs-12 col-md-9">
												<div className="title-label">
													<h2>{virtualInstallation.quote}</h2>
												</div>
											</div>
											<div className="col-xs-12">
												<div className="author-label">
													<h6>{virtualInstallation.author}</h6>
												</div>
											</div>
											<div className="col-xs-12 col-md-11">
												<div
													className="description"
													dangerouslySetInnerHTML={{
														__html: virtualInstallation.description,
													}}
												/>
											</div>
										</div>
									</div>
								</div>
								<div className="col-xs-12 col-md-7 virtual-installation-image" />
							</div>
						</div>
					</section>
					<section className="business-dev-support">
						<div className="container container-fluid">
							<div className="row text-row">
								<div className="col-xs-12 col-md-12 center-md title">
									<h3>
										{businessDevSupport.title}
									</h3>
								</div>
								<div className="col-xs-12 col-md-8 center-md description">
									<p>{businessDevSupport.shortDescription}</p>
								</div>
							</div>
							<div className="row icon-row">
								<div className="col-xs-12 col-sm-6 col-md-3 center-xs center-md title">
									<IconLabel
										key={businessDevSupport.financialText}
										description={businessDevSupport.financialText}
										svg={<FinancialSVG height="60px" />}
									/>
								</div>
								<div className="col-xs-12 col-sm-6 col-md-3 center-xs center-md title">
									<IconLabel
										key={businessDevSupport.grantsText}
										description={businessDevSupport.grantsText}
										svg={<GrantsSVG height="74px" width="58px" />}
									/>
								</div>
								<div className="col-xs-12 col-sm-6 col-md-3 center-xs center-md title">
									<IconLabel
										key={businessDevSupport.managementText}
										description={businessDevSupport.managementText}
										svg={<ManagementSVG height="60px" />}
									/>
								</div>
								<div className="col-xs-12 col-sm-6 col-md-3 center-xs center-md title">
									<IconLabel
										key={businessDevSupport.techTransferText}
										description={businessDevSupport.techTransferText}
										svg={<TechTransferSVG height="60px" />}
									/>
								</div>
							</div>
						</div>
					</section>
					<section className="biotech-equipment-services">
						<div className="container container-fluid biotech-eq-content">
							<div className="row">
								<div className="col-xs-12 col-md-9">
									<div className="container">
										<div className="row">
											<div className="col-xs-12 biotech-title">
												<h3>
													{biotechEquipmentServices.title}
												</h3>
											</div>
											<div
												className="col-xs-12 biotech-description"
												dangerouslySetInnerHTML={{
													__html: biotechEquipmentServices.text,
												}}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					<section className="question">
						<div className="container container-fluid">
							{!submittedForm ? (
								<div className="title center-xs row form">
									<div className="col-xs-12 center-xs">
										<h2>
											<FormattedMessage id="homepage.question.title" />
										</h2>
									</div>
									<div className="col-xs-12 col-md-6">
										<h6>
											<FormattedMessage id="homepage.question.description1" />
											<FormattedMessage id="homepage.question.description2" />
										</h6>
									</div>
									<div className="col-xs-12 col-md-8 center-xs">
										<div className="container">
											<Formik
												enableReinitialize
												initialValues={{
													email: '',
													question: '',
												}}
												onSubmit={(values, { setSubmitting }) => {
													setSubmitting(true);
													this.setState({ hasFormError: false });
													HomePageService.submitQuestion(values)
														.then(() => {
															setSubmitting(false);
															this.setState({
																submittedForm: true,
																hasFormError: false,
															});
														})
														.catch(() => {
															setSubmitting(false);
															this.setState({
																hasFormError: true,
															});
														});
												}}
											>
												{({
													errors,
													dirty,
													touched,
													handleSubmit,
													isSubmitting,
													isValid,
												}) => (
													<form onSubmit={handleSubmit} noValidate>
														<div className="row center-xs">
															<div className="col-xs-12 col-md-7 center-xs">
																<Field
																	component={FormTextBox}
																	type="email"
																	name="email"
																	placeholder={intl.formatMessage({
																		id: 'homepage.form.email_label',
																	})}
																	fullWidth
																	error={errors.email && touched.email}
																	validate={(value) => {
																		let error = false;
																		if (!validateEmail(value)) {
																			error = intl.formatMessage({
																				id: 'errors.invalid_email',
																			});
																		}
																		if (!value) {
																			error = intl.formatMessage({
																				id: 'errors.required',
																			});
																		}
																		return error;
																	}}
																	validationMessage={errors.email}
																	required
																/>
															</div>
															<div className="col-xs-12 col-md-7 center-xs">
																<Field
																	component={FormTextArea}
																	name="question"
																	placeholder={intl.formatMessage({
																		id: 'homepage.form.question_label',
																	})}
																	rows={7}
																	fullWidth
																	error={errors.question && touched.question}
																	validate={(value) => {
																		let error = false;
																		if (value.length < 10) {
																			error = intl.formatMessage({
																				id: 'errors.too_short',
																			});
																		}
																		if (!value) {
																			error = intl.formatMessage({
																				id: 'errors.required',
																			});
																		}

																		return error;
																	}}
																	validationMessage={errors.question}
																	required
																/>
															</div>
															<div className="col-xs-12 col-md-7 center-xs">
																<PrimaryButton
																	type="submit"
																	disabled={!isValid || !dirty || isSubmitting}
																	extraClasses="full-width"
																>
																	<FormattedMessage id="homepage.form.send_message" />
																</PrimaryButton>
															</div>
															{hasFormError && (
																<div className="col-xs-12 col-md-7 center-xs">
																	<ErrorMessage
																		label1={
																			<FormattedMessage id="error.form.submitting" />
																		}
																		label2={
																			<FormattedMessage id="error.form.submitting.try_again" />
																		}
																	/>
																</div>
															)}
														</div>
													</form>
												)}
											</Formik>
										</div>
									</div>
								</div>
							) : (
								<Success
									title={intl.formatMessage({
										id: 'homepage.form.success.title',
									})}
									description={intl.formatMessage({
										id: 'homepage.form.success.description',
									})}
								/>
							)}
						</div>
					</section>
				</div>
			</Fragment>
		);
	}
}

const mapToProps = ({ servicesPageData }) => ({
	servicesPageData,
});

export default withLocaleContext(
	injectIntl(
		connect(
			mapToProps,
			actions,
		)(ServicesPage),
	),
);

export { ServicesPage };
